import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as DashboardActions from './dashboard.actions';
import * as DashboardSelectors from './dashboard.selectors';

@Injectable({
  providedIn: 'root',
})
export class DashboardFacade {
  private store = inject(Store);

  overview$ = this.store.select(DashboardSelectors.selectDashboardOverview);
  loading$ = this.store.select(DashboardSelectors.selectDashboardLoading);
  error$ = this.store.select(DashboardSelectors.selectDashboardError);
  userStats$ = this.store.select(DashboardSelectors.selectUserStats);
  userStatsLoading$ = this.store.select(DashboardSelectors.selectUserStatsLoading);
  userStatsError$ = this.store.select(DashboardSelectors.selectUserStatsError);
  eventStats$ = this.store.select(DashboardSelectors.selectEventStats);
  eventStatsLoading$ = this.store.select(DashboardSelectors.selectEventStatsLoading);
  eventStatsError$ = this.store.select(DashboardSelectors.selectEventStatsError);
  volunteerStats$ = this.store.select(DashboardSelectors.selectVolunteerStats);
  volunteerStatsLoading$ = this.store.select(DashboardSelectors.selectVolunteerStatsLoading);
  volunteerStatsError$ = this.store.select(DashboardSelectors.selectVolunteerStatsError);

  loadOverview(): void {
    this.store.dispatch(DashboardActions.loadDashboardOverview());
  }

  loadUserStats(): void {
    this.store.dispatch(DashboardActions.loadUserStats());
  }

  loadEventStats(): void {
    this.store.dispatch(DashboardActions.loadEventStats());
  }

  loadVolunteerStats(): void {
    this.store.dispatch(DashboardActions.loadVolunteerStats());
  }

  reset(): void {
    this.store.dispatch(DashboardActions.resetDashboardState());
  }
}
